import React from 'react';
import classNames from 'classnames';
import {
  getFlagItemKey,
  getFlagItemTitle,
  getFlagSourceLabel,
  isPatientOnlyFlag
} from './flag-item-utils';
import './styles/flag-items.scss';

type FlagItemListProps = {
  flagList?: CMxAPI.FlagItem[];
};

export const FlagItemList = ({
  flagList
}: FlagItemListProps): React.ReactElement | null => {
  if (!flagList?.length) {
    return null;
  }

  return (
    <>
      {flagList.map((item, index) => {
        const sourceLabel = getFlagSourceLabel(item.flag_src);

        return (
          <div
            className={classNames('flag-item-box', {
              'flag-item-box--patient-only': isPatientOnlyFlag(item.flag_src)
            })}
            key={getFlagItemKey(item, index)}>
            {sourceLabel ? (
              <span className="flag-item-source">{sourceLabel}</span>
            ) : null}
            <p className="flag-item" title={getFlagItemTitle(item)}>
              {item.flag}
            </p>
          </div>
        );
      })}
    </>
  );
};
